import React from 'react';
import './BackgroundGraphic.css';

const BackgroundGraphic = ({ url='https://storage.googleapis.com/finiat-web-static-resources/backgrounds/blue-smoke.webp' }) => {
  return (
    <div className="background-graphic">
      <img src={url} alt="Background Graphic" />
    </div>
  );
};

export default BackgroundGraphic;